import { getRequest } from 'utils/http'

const buildQuery = ({ limit, since }) => {
  const params = []
  if (limit) params.push(`limit=${encodeURIComponent(limit)}`)
  if (since) params.push(`since=${encodeURIComponent(since)}`)
  return params.length ? `?${params.join('&')}` : ''
}

export const getMyTranscriptsApi = ({ provider, ...opts }) =>
  getRequest(
    `/integrations/${provider}/transcripts${buildQuery(opts)}`
  )

export const getUserTranscriptsApi = ({
  userId,
  provider,
  ...opts
}) =>
  getRequest(
    `/integrations/user/${userId}/${provider}/transcripts${buildQuery(
      opts
    )}`
  )
